package com.patronat.top.core.domain.usecase.command.auth

import com.patronat.top.domain.usecase.Command
import com.patronat.top.dto.UserRole

data class RegistrationUserCommand(
    val phone: String,
    val email: String?,
    val firstName: String,
    val lastName: String,
    val role: UserRole
) : Command